import { Button } from "ui/components/button";
import CreateItemButton from "components/buttons/create";
import EvtSheet from "components/sheet";
import JobTypeInput from "components/job/type/input";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import HeaderPortal from "components/portal/header-portal";

const JobTypeSelectionSheet = () => {
  const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const navigate = useNavigate();

  const handleContinue = () => {
    setOpen(false);
    navigate(`${selectedType}/+`);
  };

  return (
    <>
      <HeaderPortal>
        <PermissionControlledInput
          rule="create:PC,JC,SC,AM"
          collection="jobs"
          showWhenDisabled={false}
        >
          <CreateItemButton onClick={() => setOpen((open) => !open)}>
            Job
          </CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <EvtSheet
        open={open}
        setOpen={setOpen}
        title="Select Job Type"
        footer={
          <Button onClick={handleContinue} disabled={!selectedType}>
            Continue
          </Button>
        }
      >
        <JobTypeInput onChange={setSelectedType} />
      </EvtSheet>
    </>
  );
};

export default JobTypeSelectionSheet;
